import type { LandingStrings } from './en';

// Перевод на итальянский 2026-10-24 (по смыслу ru.ts, термины — как в игре и на странице App Store).
export const it: LandingStrings = {
  header: {
    brandSubtitle: 'Bottega magica',
    contact: 'Contatti',
    about: 'Il gioco',
    language: 'Lingua',
  },
  footer: {
    terms: 'Termini di servizio',
    privacy: 'Informativa sulla privacy',
    copyright: '{year} {holder}. Tutti i diritti riservati.',
  },
  home: {
    heroTitle: 'Un accogliente gioco in 3D tra pozioni e una bottega magica.',
    heroDescription:
      'Cerca gli ingredienti tra le cianfrusaglie magiche, prepara pozioni nel calderone e vendile nella tua bottega.',
    features: [
      {
        title: 'Il tuo flacone',
        desc: 'Forma, tappo e colore della pozione: i flaconi più belli si vendono più cari.',
      },
      {
        title: 'Un mestiere che ha senso',
        desc: 'Ogni pozione ha la sua ricetta, e molte funzionano davvero nel gioco.',
      },
      {
        title: 'Una storia da seguire',
        desc: 'La nonna è partita per una vacanza e ti ha affidato la bottega, ma una rana di nome Moren pretende ciò che gli spetta.',
      },
      {
        title: 'Una bottega davvero tua',
        desc: 'Si vende solo ciò che hai preparato con le tue mani.',
      },
    ],
    appStore: 'App Store',
    googlePlay: 'Google Play',
    comingSoon: 'In arrivo',
    tags: { search: 'Ingredienti nascosti', craft: 'Pozioni nel calderone 3D', shop: 'Bottega accogliente' },
  },
  about: {
    title: 'Informazioni su Qevryno',
    intro: [
      'Ti diamo il benvenuto in Qevryno, un gioco accogliente in cui si preparano pozioni e la magia è fatta a mano.',
      'La nonna è partita per una vacanza e ti ha chiesto di badare alla sua misteriosa vecchia casa: ricette dimenticate, ingredienti magici e un calderone che si ricorda ancora come bollire. Al piano di sotto c’è una piccola bottega, e tutto il villaggio si chiede già chi se ne occupi ora.',
      'Prepara pozioni, prenditi cura del tuo soffice famiglio, vendi le tue creazioni a clienti adorabili e guadagna monete per decorare la tua casa magica, al tuo ritmo e senza timer.',
    ],
    whatTitle: 'Che tipo di gioco è?',
    what: [
      'Qevryno è un rilassante gioco di puzzle in 3D che unisce ricerca di oggetti, crafting alchemico e un piccolo simulatore di bottega. Se ami i giochi cozy, i puzzle casual, i giochi di oggetti nascosti, i giochi di pozioni, l’alchimia e l’idea di un negozio magico tutto tuo, è il gioco che fa per te.',
      'È un gioco single player che funziona offline; la connessione serve solo per gli acquisti e per i video facoltativi con ricompensa. Niente banner né pop-up pubblicitari: un breve video Google AdMob in cambio di un bonus parte solo se lo avvii tu. Acquisti facoltativi: gemme e pacchetti di ingredienti dal contenuto visibile. Uscirà presto su iOS e Android, in italiano, inglese, russo, spagnolo, tedesco, francese, olandese, portoghese (Brasile), polacco, giapponese, coreano, cinese tradizionale e turco.',
    ],
    doTitle: 'Cosa farai',
    doList: [
      'Cercare ingredienti nascosti in magiche radure 3D nel bosco: ognuna è come un piccolo diorama.',
      'Preparare ricette magiche nel calderone: uno stabilizzatore, un ingrediente principale, le erbe del tempo e un tocco di colore.',
      'Creare i tuoi flaconi: forma, tappo e colore della pozione; i più belli si vendono più cari.',
      'Gestire la tua bottega: clienti, reputazione, fiere e missioni.',
      'Seguire la storia: la nonna è partita per una vacanza e ti ha affidato la bottega, ma una rana di nome Moren continua a pretendere ciò che gli spetta.',
      'Macinare nel mortaio ciò che trovi, mescolarlo nella ciotola e aggiungere brillantini: ogni miscela ha consistenza e colore propri.',
      'Nutrire il tuo famiglio e decorare la bottega.',
    ],
    faqTitle: 'Domande frequenti',
    faq: [
      { q: 'Qevryno è gratis?', a: 'Sì. Il gioco è gratuito e ci si può giocare senza pagare. Acquisti facoltativi: gemme e pacchetti di ingredienti.' },
      { q: 'Funziona offline?', a: 'Sì. Il gioco in sé non ha bisogno di connessione: prepara pozioni in aereo o sotto una coperta. Internet serve solo per gli acquisti e per i video facoltativi con ricompensa.' },
      { q: 'C’è pubblicità?', a: 'Solo facoltativa. Non ci sono banner né pop-up tra una schermata e l’altra. In alcuni punti puoi scegliere di guardare un breve video per ottenere un bonus, per esempio del mana. Nel gioco niente ti obbliga a guardarli. I video sono forniti da Google AdMob; per i dettagli, consulta l’Informativa sulla privacy.' },
      { q: 'Su quali piattaforme?', a: 'iOS e Android, in italiano, inglese, russo, spagnolo, tedesco, francese, olandese, portoghese (Brasile), polacco, giapponese, coreano, cinese tradizionale e turco.' },
      { q: 'Fa paura o mette ansia?', a: 'Per niente. È un gioco calmo e accogliente: musica dolce, nessuna punizione per gli errori e un gatto con il cappello.' },
    ],
  },
  contact: {
    title: 'Contattaci',
    subtitle: 'Una domanda su Qevryno, un bug, un acquisto o un annuncio? Scrivici via email.',
    write: 'Scrivi un’email',
    mailSubject: 'Qevryno: assistenza',
    tip: 'Dicci che dispositivo usi e cosa è successo: così è più facile aiutarti.',
    info: {
      title: 'Contatti',
      email: 'Email',
      security: 'Sicurezza',
      legalName: 'Sviluppatrice',
      address: 'Indirizzo',
    },
    refunds: {
      title: 'Rimborsi e acquisti',
      description: 'Tutti gli acquisti passano dall’Apple App Store o da Google Play. Per chiedere un rimborso, rivolgiti allo store:',
      apple: 'Apple App Store',
      appleUrl: 'https://support.apple.com/it-it/HT204084',
      google: 'Google Play',
      googleUrl: 'https://support.google.com/googleplay/answer/2479637?hl=it',
      link: 'Richiedi un rimborso',
      note: 'Non riceviamo pagamenti direttamente e non possiamo effettuare rimborsi. Se un acquisto non è arrivato nel gioco, apri «Impostazioni → Ripristina acquisti» oppure scrivici.',
    },
  },
  legal: {
    dataController: 'Titolare del trattamento',
    // Политика и условия есть на английском, русском и испанском; для остальных языков страница показывает английский текст и эту строку
    onlyIn: 'Questo documento è disponibile solo in inglese, russo e spagnolo. Qui sotto trovi la versione inglese.',
  },
};
